// @ts-expect-error https://vite.dev/config/build-options.html#build-modulepreload
import "vite/modulepreload-polyfill";
window.global ||= window;
// TODO: Remove polyfills
import "./polyfill/polyfills.js";
import "./vendor/vendor.js";
import "../scss/brands.scss";

import { brandModules } from "./pages/brands/config";
import { createXylemApp } from "./createXylemApp";
import { initializeFontAwesome } from "./core/fontawesome";

initializeFontAwesome();
await createXylemApp({ modules: brandModules });
